import { columns } from "../../../../dtos/columns";
import { DetalleArchivoRecaudadoDto } from "../models/registrarRecaudacionMasiva";

export function useColumns() {
    const COLUMNS: columns<DetalleArchivoRecaudadoDto>[] = [
        {
            name: 'N° operación',
            selector: (row) => row.numeroOperacionMutuo,
            sortable: true,
            sortField: 'numeroOperacionMutuo',
            wrap: true,
            export: true
        },
        {
            name: 'N° dividendo',
            selector: (row) => row.numeroDividendo,
            sortable: true,
            sortField: 'numeroDividendo',
            wrap: true,
            export: true
        },
        {
            name: 'Monto en pesos',
            selector: (row) => row.montoDividendo,
            sortable: true,
            sortField: 'montoDividendo',
            wrap: true,
            export: true
        },
        {
            name: 'Total recaudado',
            selector: (row) => row.montoEfectivo || null,
            sortable: true,
            sortField: 'montoEfectivo',
            wrap: true,
            export: true
        },
        {
            name: 'Fecha vencimiento',
            selector: (row) => row.fechaVencimiento ? new Date(row.fechaVencimiento).toLocaleDateString() : "",
            sortable: true,
            sortField: 'fechaVencimiento',
            wrap: true,
            export: true
        },
        {
            name: 'Fecha recaudación',
            selector: (row) => row.fechaRecaudacion ? new Date(row.fechaRecaudacion).toLocaleDateString() : "",
            sortable: true,
            sortField: 'fechaRecaudacion',
            wrap: true,
            export: true
        },
        {
            name: 'Nombre cliente',
            selector: (row) => row.nombreCliente,
            sortable: true,
            sortField: 'nombreCliente',
            wrap: true,
            export: true
        },
        {
            name: 'Origen archivo',
            selector: (row) => row.tipoArchivo,
            sortable: true,
            sortField: 'tipoArchivo',
            wrap: true,
            export: true
        },
        {
            name: 'Fecha carga archivo',
            selector: (row) => row.fechaCarga ? new Date(row.fechaCarga).toLocaleDateString() : "",
            sortable: true,
            sortField: 'fechaCarga',
            wrap: true,
            export: true
        },      
    ];

    return { COLUMNS };
}